<template lang="pug">
//- Outline of a long page (rounds, headings). `items`: [{ id, label, sub? }]; `activeId` highlights the current one.
details.outline-nav(v-for="mode in ['desktop', 'mobile']", :key="mode", :class="'outline-nav--' + mode", :open="mode === 'desktop' && open")
  summary.section-heading {{ title }}
  ol
    li(v-for="item in items", :key="item.id", :class="{ active: activeId === item.id }")
      a(:href="'#' + item.id")
        span.outline-label {{ item.label }}
        span.outline-sub(v-if="item.sub") {{ item.sub }}
</template>

<script>
export default {
  name: 'OutlineNav',
  props: {
    title: { type: String, required: true },
    items: { type: Array, default: () => [] },
    activeId: { type: String, default: '' },
    open: { type: Boolean, default: true },
  },
}
</script>

<style lang="sass">
.outline-nav--mobile
  display: none
@media (max-width: 991px)
  .outline-nav--desktop
    display: none
  .outline-nav--mobile
    display: block
.outline-nav
  border-top: 1px solid var(--line)
  padding-top: 14px
  summary
    cursor: pointer
    list-style: none
    &::-webkit-details-marker
      display: none
  ol
    list-style: none
    padding: 0
    margin: 0
    display: grid
    gap: 2px
  li
    position: relative
    &.active
      a
        color: var(--gold)
        background: var(--tint-1)
      .outline-label
        color: var(--gold)
      &::before
        content: ''
        position: absolute
        left: -12px
        top: 0.95em
        width: 6px
        height: 6px
        border-radius: 50%
        background: var(--gold)
  a
    display: grid
    grid-template-columns: auto 1fr
    gap: 8px
    padding: 6px 8px
    color: var(--ink-3)
    text-decoration: none
    border-radius: var(--r-sm)
    font-size: 0.86rem
    line-height: 1.5
    transition: var(--t-hover)
    &:hover
      background: var(--tint-2)
      color: var(--ink)
      text-decoration: none
  .outline-label
    color: var(--ink-4)
    letter-spacing: 0.06em
    font-size: 0.74rem
    padding-top: 2px
    white-space: nowrap
  .outline-sub
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
    overflow: hidden
  li a:has(.outline-sub:empty)
    grid-template-columns: 1fr

  @media (max-width: 991px)
    summary
      padding: 8px 0
      &::after
        content: ' ▾'
        color: var(--ink-4)
</style>
